import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-customer-verification',
  templateUrl: './customer-verification.component.html',
  styleUrls: ['./customer-verification.component.scss']
})
export class CustomerVerificationComponent implements OnInit {

  constructor( private act:ActivatedRoute) { }

  ngOnInit(): void {
    // this.act.queryParams.subscribe(params => {
    //   console.log(params);
    // });
  }

}
